/* eslint-disable react/jsx-key */
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Card, Icon, Modal, Badge, message, Typography } from 'antd';
import { deletePage } from '../../../actions/pages.actions';
import moment from 'moment';

import './PageCard.css';

const { Meta } = Card;
const { confirm } = Modal;
const { Paragraph } = Typography;

const PageCard = props => {
    const { path: pagePath, title: pageTitle, description: pageDescription } = props.page;
    const { subpages, statusProps } = props.page;

    const title = pageTitle + ' (' + pagePath + ')';
    const editUrl = '/edit' + pagePath;
    const viewUrl = '/view' + pagePath;

    const deletePageHandler = () => {
        if (props.index === pagePath) {
            message.error('Unable to delete page: this page is configured as the index page. Please configure another page as index before deleting this one.');
            return;
        }
        confirm({
            title: "Are you sure you'd like to remove this page?",
            content: 'In case this page has subpages, they will be deleted as well.',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            cancelType: 'default',

            onOk: () => {
                props.deletePage({ path: pagePath, title: pageTitle });
            }
        });
    };
    const pageClickedHandler = e => {
        props.onClick && props.onClick(props.page);
    };
    const createStatusIcons = () => {
        let icons = [];

        /** ~~~~~~~~~ Published state status icon ~~~~~~~~~ **/
        const lastSaved = statusProps && statusProps.lastSaved ? moment(new Date(statusProps.lastSaved.utcTimeStamp)) : undefined;
        const lastPublished = statusProps && statusProps.lastPublished ? moment(new Date(statusProps.lastPublished.utcTimeStamp)) : undefined;
        const publishLocation = statusProps && statusProps.publishLocation ? statusProps.publishLocation : undefined;

        if (lastSaved && lastPublished && publishLocation) {
            if (lastPublished.isAfter(lastSaved) && publishLocation === props.page.path) {
                icons.push(<Icon key="1" type="cloud" theme="filled" className="statusIcon--success" title="Published" />);
            } else {
                icons.push(<Icon key="1" type="cloud" theme="filled" className="statusIcon--warning" title="Outdated version on publish environment" />);
            }
        } else {
            icons.push(<Icon key="1" type="cloud" theme="filled" className="statusIcon--error" title="Not published yet" />);
        }

        /** ~~~~~~~~~ Subpages count status icon ~~~~~~~~~ **/
        const subpagesCount = Object.keys(props.page.subpages).length;
        icons.push(
            <Badge count={subpagesCount} showZero overflowCount={9} key="2">
                <Icon type="container" theme="filled" className="statusIcon--primary" title={'Subpages ' + subpagesCount} />
            </Badge>
        );

        return icons;
    };

    const createPageCardOverlay = () => {
        let lastEditBlock = '';
        let lastPublishedBlock = '';

        if (statusProps && statusProps.lastSaved) {
            let dateTimeStamp = moment(new Date(statusProps.lastSaved.utcTimeStamp));

            lastEditBlock = (
                <React.Fragment>
                    <div className="pageCard-infoItem">
                        <span className="pageCard-infoItem-label">Last edit:</span>
                        <span className="pageCard-infoItem-data">{dateTimeStamp.format('ddd, D MMM YYYY, H:mm')}</span>
                    </div>
                    <div className="pageCard-infoItem">
                        <span className="pageCard-infoItem-data"> - {statusProps.lastSaved.user}</span>
                    </div>
                </React.Fragment>
            );
        }

        if (statusProps && statusProps.lastPublished) {
            let dateTimeStamp = moment(new Date(statusProps.lastPublished.utcTimeStamp));

            lastPublishedBlock = (
                <React.Fragment>
                    <div className="pageCard-infoItem">
                        <span className="pageCard-infoItem-label">Last publish:</span>
                        <span className="pageCard-infoItem-data">{dateTimeStamp.format('ddd, D MMM YYYY, H:mm')}</span>
                    </div>
                    <div className="pageCard-infoItem">
                        <span className="pageCard-infoItem-data"> - {statusProps.lastPublished.user}</span>
                    </div>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                <div className="pageCard-infoItem">
                    <span className="pageCard-infoItem-label">Subpages:</span>
                    <span className="pageCard-infoItem-data">{subpages ? Object.keys(subpages).length : '0'}</span>
                </div>
                {lastEditBlock}
                {lastPublishedBlock}
                {subpages && Object.keys(subpages).length > 0 ? <Icon type="select" /> : null}
            </React.Fragment>
        );
    };

    return (
        <div className="PageCard">
            <div className="PageCard-overlay" onClick={pageClickedHandler}>
                {createPageCardOverlay()}
            </div>
            <Card
                style={{ width: 250 }}
                actions={[
                    <Icon type="delete" className="clickable" theme="filled" style={{ color: '#f5222d' }} onClick={deletePageHandler} />,
                    <Link to={viewUrl}>
                        <Icon type="eye" className="clickable" theme="filled" style={{ color: '#1890ff' }} />
                    </Link>,
                    <Link to={editUrl}>
                        <Icon type="edit" className="clickable" theme="filled" style={{ color: '#1890ff' }} />
                    </Link>
                ]}>
                <Meta
                    title={title}
                    description={
                        <Paragraph style={{ color: 'rgba(0, 0, 0, 0.45)' }} ellipsis={{ rows: 3 }}>
                            {pageDescription}
                        </Paragraph>
                    }
                    avatar={createStatusIcons()}
                />
            </Card>
        </div>
    );
};

const mapStateToProps = state => ({
    index: state.pages.index
});

const mapDispatchToProps = {
    deletePage
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PageCard);
